export default "__VITE_ASSET__4fPe0KHi__"